import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";

import SplashLoader from "./components/SplashLoader";

import Home from "./pages/Home";
import About from "./pages/About";
import Activities from "./pages/Activities";
import News from "./pages/News";
import Gallery from "./pages/Gallery";
import ActivityDetail from "./pages/ActivityDetail";
import NewsDetail from "./pages/NewsDetail";
import GalleryViewer from "./pages/GalleryViewer";

import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const alreadyLoaded = sessionStorage.getItem("firstLoadDone");

    if (alreadyLoaded) {
      setShowSplash(false);
    } else {
      setTimeout(() => {
        sessionStorage.setItem("firstLoadDone", "true");
        setShowSplash(false);
      }, 2200);
    }
  }, []);

  // 🔥 SHOW ONLY SPLASH FIRST
  if (showSplash) {
    return <SplashLoader onFinish={() => setShowSplash(false)} />;
  }

  return (
    <BrowserRouter future={{ v7_startTransition: true }}>
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/activities" element={<Activities />} />
        <Route path="/activities/:type" element={<Activities />} />
        <Route path="/activities/view/:id" element={<ActivityDetail />} />

        <Route path="/news/:id" element={<NewsDetail />} />

        <Route path="/gallery" element={<Gallery />} />
        <Route path="/gallery/view/:id" element={<GalleryViewer />} />

        <Route path="/news" element={<News />} />
        <Route path="/about" element={<About />} />

        <Route path="/sgya-admin-secure-login" element={<AdminLoginPage />} />

        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;